var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-col',[_c('reportTableDashboard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }